import { batch } from 'react-redux';

import { doRequest } from '@r1-frontend/do-request';
import { activation } from '@r1-frontend/api-domru/api-vas/v1/vas';
import { IRequestParams } from '@r1-frontend/api-domru/api-vas/v1/vas/activation/dto/requestDto';
import { IActivationResponse } from '@r1-frontend/api-domru/api-vas/v1/vas/activation/dto/responseDto';

import { EResultPopupStatus } from '@r1-frontend/ui-react/components/popups/popupResult';

import { speedBonusConnectionAnalytics } from '~/src/entities/speed-bonus/analytics';
import { TContextDispatch } from '~/src/entities/speed-bonus/context';
import { goToNextStep, setResult, toggleIsLoading, toggleIsShowConnection } from '~/src/entities/speed-bonus/context/actions';
import { TActionResult } from '~/src/entities/speed-bonus/context/actions/setResult';
import { fetchConnectPrice } from '~/src/entities/speed-bonus/context/actions/thunk';
import { Plus100Status } from '~/src/entities/speed-bonus/context/constants';
import { TInitialState } from '~/src/entities/speed-bonus/context/reducer';

export const activate = () => async(dispatch: TContextDispatch, getState: () => TInitialState) => {
    const { isShowConnection, tariff, routers, connectionCost, businessLogic } = getState();

    if (!tariff) {
        return;
    }

    dispatch(toggleIsLoading(true));

    const reqParams: IRequestParams = {
        socId: tariff.socId,
        contactId: businessLogic?.contactId,
        bonusId: tariff.bonusId,
        speedBonusStatus: tariff.speedBonusStatus,
        specialOffersRequestIds: tariff.specialOffersRequestIds,
    };

    const selectedRouter = routers.find(router => router.quantity);

    if (selectedRouter) {
        reqParams.router = {
            id: selectedRouter.id,
            duration: selectedRouter.selectedPrice.duration,
        };
    }

    const response = await doRequest.apiVas<IActivationResponse>(activation(reqParams));

    if (response.isSuccess) {
        if (tariff.speedBonusStatus !== Plus100Status) {
            speedBonusConnectionAnalytics.successConnected();
        }

        const successResult: TActionResult = {
            entity: 'activation',
            status: EResultPopupStatus.SUCCESS,
            header: response.payload.header,
            message: response.payload.message,
        };

        if (response.payload.requestIds?.length) {
            speedBonusConnectionAnalytics.requestCreated(tariff.speedBonusStatus === Plus100Status);

            if (!connectionCost) {
                dispatch(fetchConnectPrice());
            }

            batch(() => {
                dispatch(goToNextStep());
                dispatch(setResult({
                    ...successResult,
                    target: 'alert',
                }));
            });

            if (!isShowConnection) {
                businessLogic?.beforeSwitchToConnection && businessLogic.beforeSwitchToConnection();

                dispatch(toggleIsShowConnection(true));
            }
        } else {
            dispatch(setResult(successResult));
        }
    } else {
        speedBonusConnectionAnalytics.connectionError();

        dispatch(setResult({
            entity: 'activation',
            status: EResultPopupStatus.ERROR,
            header: 'Что-то пошло не так. Попробуйте ещё раз.',
            message: response.error.message,
        }));
    }

    dispatch(toggleIsLoading(false));
};
